import { css } from '@emotion/css';

export const pageBackground = css`
  background: var(--colors-neutrals-20);
`;

export const privyContainer = css`
  padding: 16px;
  position: relative;

  .header {
    display: flex;
    gap: 16px;
    margin-bottom: 16px;
    align-items: center;
    justify-content: center;
    margin: 16px 0 24px 0;
  }

  .blue-card {
    background: linear-gradient(
      180deg,
      var(--colors-primary-30) 0%,
      var(--colors-primary-40) 100%
    );
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    width: 100%;
    height: 200px;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 0;
  }

  .card {
    position: relative;
    z-index: 1;
    background: var(--colors-neutrals-10);
    border-radius: 8px;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 4px;
    padding: 16px;

    .flex {
      display: flex;
      flex-direction: column;
      gap: 16px;
      margin-top: 16px;
    }

    .flex-col {
      display: flex;
      align-items: center;
      gap: 10px;

      svg {
        flex-shrink: 0;
      }
    }

    p > span {
      color: var(--colors-primary-30);
    }

    .footer {
      border-top: 1px dashed var(--colors-neutrals-40);
      padding-top: 12px;
      margin-top: 12px;
      cursor: pointer;
    }
  }
`;
